import BaseProxy from './Proxy';

export default class PingSessionProxy extends BaseProxy {
  constructor() {
    super('api/pingSession', {});
  }
}
